(function(){
  'use strict';
  function initEntrance(root){
    root = root || document;
    var el = root.querySelector ? root.querySelector('[data-melo-entrance]') : null;
    if(!el) return;
    var mode = el.getAttribute('data-display-mode') || 'session';
    var key = 'melo-entrance-seen';
    var designMode = !!(window.Shopify && Shopify.designMode);
    var seen = false;
    try { seen = mode === 'session' ? sessionStorage.getItem(key) === '1' : mode === 'visitor' ? localStorage.getItem(key) === '1' : false; } catch(e){}
    if(seen && !designMode){ el.hidden = true; return; }
    el.hidden = false;
    function remember(){
      try { if(mode === 'session') sessionStorage.setItem(key,'1'); if(mode === 'visitor') localStorage.setItem(key,'1'); } catch(e){}
    }
    function close(){ remember(); el.hidden = true; document.documentElement.classList.remove('melo-entry-open'); }
    document.documentElement.classList.add('melo-entry-open');
    var closeBtn=el.querySelector('[data-melo-entry-close]'); if(closeBtn) closeBtn.addEventListener('click',close);
    el.querySelectorAll('[data-melo-entry-link]').forEach(function(a){ a.addEventListener('click',remember); });
    el.addEventListener('keydown',function(e){ if(e.key==='Escape' && closeBtn) close(); });
  }
  function init(){initEntrance(document)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',function(e){initEntrance(e.target)});
})();
